import React from "react";
import {FormFieldLine} from "../../../../../components/form-field-line/form-field-line";
import {IOption, SelectDropdown,} from "../../../../../components/inputs/select-dropdown/select-dropdown";
import {GlobalEEnvironment} from "../../../../../services/api/admin-migrate-global-e-merchants-service";
import {SingleValue} from "react-select";

const environmentOptions: IOption[] = [
    {
        value: GlobalEEnvironment.PROD,
        label: "Production (Live merchant)",
    },
    {
        value: GlobalEEnvironment.INT,
        label: "INT",
    },
    {
        value: GlobalEEnvironment.STG,
        label: "STG",
    },
    {
        value: GlobalEEnvironment.QA,
        label: "QA",
    },
];

interface IGlobaleEnvironmentSelectorProps {
    onChange?: (env: GlobalEEnvironment) => void;
    value?: GlobalEEnvironment;
    disbled?: boolean;
}

const GlobaleEnvironmentSelector: React.FC<IGlobaleEnvironmentSelectorProps> = ({ onChange, value, disbled = false }) => {
    
    const selectedOption = environmentOptions.find(o => o.value === value) || null;

    const handleChange = (option: SingleValue<IOption>) => {
        const env = option?.value as GlobalEEnvironment;
        onChange?.(env);
    }

    return (
        <FormFieldLine label="Global-e Environment">
            <SelectDropdown
                isSearchable={false}
                value={selectedOption}
                options={environmentOptions}
                onChange={handleChange}
                placeholder="Select environment"
                required={true}
                disabled={disbled}
            />
        </FormFieldLine>
    );
};

export default GlobaleEnvironmentSelector;